"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderLineItem_type = void 0;
/**
 * The type of line item
 */
var OrderLineItem_type;
(function (OrderLineItem_type) {
    OrderLineItem_type["REGISTRATION_FEE"] = "registration_fee";
    OrderLineItem_type["ADJUSTMENT"] = "adjustment";
    OrderLineItem_type["FEE"] = "fee";
    OrderLineItem_type["CREDIT"] = "credit";
    OrderLineItem_type["PARTNER_OFFERING"] = "partner_offering";
})(OrderLineItem_type || (exports.OrderLineItem_type = OrderLineItem_type = {}));
